(() => {
  'use strict';
  if (window.__SQ_HEART_PROTECTION_ZONE_V2__) return;
  window.__SQ_HEART_PROTECTION_ZONE_V2__ = true;
  window.__SQ_HEART_PROTECTION_ZONE_V1__ = true;

  const PRIMARY_CARD = '.sq-universal-card,[data-sq-universal-card],product-card,.product-card,.sq-product-card,.product-slider-belt-card,.sq-smart-picks__item,[data-lcs-favorite-card],.lcs-favorite-card,[data-sqyml2-card],[data-lcs-recommend-card],.premium-recommend-card-shell,.premium-recommend-card,.premium-gallery-card,.sq-search-card,.sq-search-grid-card,.sq-search-recent-card,.sq-search-trending-card,.predictive-search__product-card,[data-product-card],[data-product-slider-card]';
  const FALLBACK_CARD = '[data-product-id][data-product-url],[data-product-id][data-product-handle]';
  const HEART = '.sq-card-favorite-control,.sq-universal-card__favorite,.sq-search-card__favorite,.lcs-favorite-card__heart-remove,.sq-search-favorite-btn,[data-sq-card-favorite-control],[data-sq-universal-favorite],[data-sq-favorite-control],[data-lcs-favorite-toggle],[data-lcs-favorite-remove],[data-sqyml2-favorite],[data-lcs-recommend-favorite],[data-sqyml2-save],[data-lcs-recommend-save],[data-product-favorite],[data-favorite-button],[data-lcs-product-favorite],[data-sq-product-favorite]';
  const EDITORIAL = '[data-sqf-editorial-slider],[data-sq-editorial-no-commerce-controls],[data-sq-editorial-no-card-controls],[data-sq-editorial-no-bag],.sq-launch-journal,.sq-article-world-card,.sq-article-more-stories,.sq-journal-explorer,.sq-story-collections,.sq-journal-collection-card,.sq-launch-story-card';
  const OWNER_ATTR = 'data-sq-heart-local-owner';
  const CONTROL_ATTR = 'data-sq-heart-local-control';
  const ZONE_ATTR = 'data-sq-heart-protection-zone';
  const OWNER = `[${OWNER_ATTR}]`;
  const ZONE = `[${ZONE_ATTR}]`;
  const LOCAL = 'is-sq-heart-local-visible';
  const cards = new Set();
  let activeCard = null;
  let scanFrame = 0;
  let resizeFrame = 0;

  const editorial = el => el instanceof Element && !!el.closest(EDITORIAL);
  const saved = heart => heart instanceof Element && (heart.classList.contains('is-saved') || heart.hasAttribute('data-sq-favorite-saved') || heart.getAttribute('aria-pressed') === 'true');
  const ownerFor = heart => {
    if (!(heart instanceof Element) || editorial(heart)) return null;
    const card = heart.closest(PRIMARY_CARD) || heart.closest(FALLBACK_CARD);
    return card instanceof HTMLElement && !editorial(card) ? card : null;
  };
  const heartsFor = card => card instanceof HTMLElement ? [...card.querySelectorAll(HEART)].filter(heart => heart instanceof HTMLElement && !heart.hidden && !heart.disabled && heart.getAttribute('aria-hidden') !== 'true' && !editorial(heart) && ownerFor(heart) === card) : [];
  const bestHeart = card => heartsFor(card).find(heart => {
    const rect = heart.getBoundingClientRect();
    return getComputedStyle(heart).display !== 'none' && rect.width > 0 && rect.height > 0;
  }) || heartsFor(card)[0] || null;

  const installStyle = () => {
    if (document.getElementById('sq-heart-local-reveal-v2')) return;
    const style = document.createElement('style');
    style.id = 'sq-heart-local-reveal-v2';
    style.textContent = `html body [${CONTROL_ATTR}]:not(.is-saved):not([data-sq-favorite-saved]):not([aria-pressed='true']){opacity:0!important;visibility:hidden!important;pointer-events:none!important}html body [${CONTROL_ATTR}].${LOCAL}:not(.is-saved):not([data-sq-favorite-saved]):not([aria-pressed='true']){opacity:1!important;visibility:visible!important;pointer-events:auto!important;transform:none!important}html body [${CONTROL_ATTR}]:is(.is-saved,[data-sq-favorite-saved],[aria-pressed='true']){opacity:1!important;visibility:visible!important;pointer-events:auto!important;transform:none!important}`;
    (document.head || document.documentElement).appendChild(style);
  };

  const ensurePosition = card => {
    if (getComputedStyle(card).position === 'static') {
      card.style.position = 'relative';
      card.setAttribute('data-sq-heart-zone-position-owner', 'true');
    }
  };
  const placeZone = (card, heart, zone) => {
    ensurePosition(card);
    const c = card.getBoundingClientRect();
    const h = heart.getBoundingClientRect();
    if (!c.width || !c.height) return;
    const w = Math.min(56, Math.max(1, c.width));
    const ht = Math.min(56, Math.max(1, c.height));
    let left = c.width - w - 4;
    let top = 4;
    if (h.width && h.height) {
      left = h.left - c.left + h.width / 2 - w / 2;
      top = h.top - c.top + h.height / 2 - ht / 2;
    }
    left = Math.max(0, Math.min(left, Math.max(0, c.width - w)));
    top = Math.max(0, Math.min(top, Math.max(0, c.height - ht)));
    Object.assign(zone.style, { left:`${Math.round(left)}px`, top:`${Math.round(top)}px`, width:`${Math.round(w)}px`, height:`${Math.round(ht)}px` });
  };
  const createZone = card => {
    const zone = document.createElement('span');
    zone.setAttribute(ZONE_ATTR, '');
    zone.setAttribute('aria-hidden', 'true');
    zone.tabIndex = -1;
    Object.assign(zone.style, { position:'absolute',display:'block',boxSizing:'border-box',margin:'0',padding:'0',border:'0',outline:'0',background:'transparent',backgroundColor:'transparent',opacity:'1',visibility:'visible',pointerEvents:'auto',zIndex:'2147483000',cursor:'pointer',userSelect:'none',WebkitTapHighlightColor:'transparent' });
    card.appendChild(zone);
    return zone;
  };
  const installCard = card => {
    if (!(card instanceof HTMLElement) || editorial(card)) return;
    const hearts = heartsFor(card);
    if (!hearts.length) return;
    card.setAttribute(OWNER_ATTR, '');
    hearts.forEach(heart => heart.setAttribute(CONTROL_ATTR, ''));
    const heart = bestHeart(card) || hearts[0];
    let zone = card.querySelector(`:scope > ${ZONE}`);
    if (!zone) zone = createZone(card);
    zone.__sqHeartOwner = heart;
    cards.add(card);
    placeZone(card, heart, zone);
  };
  const scan = scope => {
    const hearts = [];
    if (scope instanceof Element) {
      if (scope.matches(HEART)) hearts.push(scope);
      scope.querySelectorAll?.(HEART).forEach(heart => hearts.push(heart));
    } else document.querySelectorAll(HEART).forEach(heart => hearts.push(heart));
    const owners = new Set();
    hearts.forEach(heart => { const card = ownerFor(heart); if (card) owners.add(card); });
    owners.forEach(installCard);
  };
  const scheduleScan = scope => {
    if (scanFrame) return;
    scanFrame = requestAnimationFrame(() => { scanFrame = 0; scan(scope || document); });
  };
  const refresh = () => {
    [...cards].forEach(card => {
      if (!card.isConnected) return cards.delete(card);
      const zone = card.querySelector(`:scope > ${ZONE}`);
      const heart = zone?.__sqHeartOwner && ownerFor(zone.__sqHeartOwner) === card ? zone.__sqHeartOwner : bestHeart(card);
      if (zone && heart) { zone.__sqHeartOwner = heart; placeZone(card, heart, zone); }
      else installCard(card);
    });
  };
  const scheduleRefresh = () => {
    if (resizeFrame) return;
    resizeFrame = requestAnimationFrame(() => { resizeFrame = 0; refresh(); });
  };

  const localCard = target => {
    const card = target instanceof Element ? target.closest(OWNER) : null;
    return card instanceof HTMLElement && !editorial(card) ? card : null;
  };
  const hideCard = card => {
    if (!(card instanceof HTMLElement)) return;
    heartsFor(card).forEach(heart => { if (!saved(heart)) heart.classList.remove(LOCAL); });
    card.classList.remove('is-heart-visible');
    if (activeCard === card) activeCard = null;
  };
  const revealCard = card => {
    if (!(card instanceof HTMLElement)) return;
    if (activeCard && activeCard !== card) hideCard(activeCard);
    heartsFor(card).forEach(heart => { if (!saved(heart)) heart.classList.add(LOCAL); });
    card.classList.add('is-heart-visible');
    activeCard = card;
  };

  window.addEventListener('pointerover', event => {
    if (event.pointerType === 'touch') return;
    const card = localCard(event.target);
    if (card) revealCard(card);
  }, true);
  window.addEventListener('pointerout', event => {
    if (event.pointerType === 'touch') return;
    const from = localCard(event.target);
    if (!from) return;
    const to = localCard(event.relatedTarget);
    if (to === from) return;
    if (to) revealCard(to); else hideCard(from);
  }, true);
  window.addEventListener('pointerdown', event => {
    const card = localCard(event.target);
    if (card) revealCard(card); else if (activeCard) hideCard(activeCard);
  }, true);

  const intentFor = event => {
    const zone = event.target instanceof Element ? event.target.closest(ZONE) : null;
    if (!(zone instanceof HTMLElement)) return null;
    const card = zone.closest(OWNER);
    if (!(card instanceof HTMLElement) || editorial(card)) return null;
    const heart = zone.__sqHeartOwner && ownerFor(zone.__sqHeartOwner) === card ? zone.__sqHeartOwner : bestHeart(card);
    return { card, heart };
  };
  const heartAvailable = (heart, card) => {
    if (!(heart instanceof HTMLElement) || ownerFor(heart) !== card || heart.disabled || heart.hidden || heart.getAttribute('aria-hidden') === 'true') return false;
    const style = getComputedStyle(heart);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number.parseFloat(style.opacity || '1') > .01 && (heart.classList.contains(LOCAL) || card.classList.contains('is-heart-visible') || saved(heart));
  };
  const insideHeart = (event, heart) => {
    if (!(heart instanceof HTMLElement)) return false;
    const rect = heart.getBoundingClientRect();
    const x = Number(event.clientX), y = Number(event.clientY);
    return rect.width > 0 && rect.height > 0 && Number.isFinite(x) && Number.isFinite(y) && x >= rect.left && x <= rect.right && y >= rect.top && y <= rect.bottom;
  };

  window.addEventListener('pointerdown', event => {
    if (!intentFor(event)) return;
    event.stopPropagation();
    event.stopImmediatePropagation();
  }, true);
  window.addEventListener('mousedown', event => {
    if (!intentFor(event)) return;
    event.stopPropagation();
    event.stopImmediatePropagation();
  }, true);
  window.addEventListener('click', event => {
    const intent = intentFor(event);
    if (!intent) return;
    const favorite = intent.heart && heartAvailable(intent.heart, intent.card) && insideHeart(event, intent.heart);
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    if (favorite && !intent.heart.__sqHeartShieldProxying) {
      intent.heart.__sqHeartShieldProxying = true;
      try { intent.heart.click(); } catch (_) {}
      queueMicrotask(() => { intent.heart.__sqHeartShieldProxying = false; });
    }
  }, true);

  window.addEventListener('resize', scheduleRefresh, { passive:true });
  window.addEventListener('pageshow', () => { scheduleScan(document); scheduleRefresh(); });
  document.addEventListener('shopify:section:load', event => { scan(event.target); scheduleRefresh(); });

  const start = () => {
    installStyle();
    scan(document);
    [80,260,700].forEach(delay => setTimeout(() => { scan(document); refresh(); }, delay));
    if (!document.body || !window.MutationObserver) return;
    new MutationObserver(records => {
      for (const record of records) for (const node of record.addedNodes) {
        if (node instanceof Element && (node.matches(HEART) || node.querySelector?.(HEART))) { scheduleScan(node); return; }
      }
    }).observe(document.body, { childList:true, subtree:true });
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start, { once:true }) : start();
})();
